import React, { useState } from "react";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Paper from '@material-ui/core/Paper';

let tg = window.Telegram.WebApp;

tg.MainButton.text = "Отправить"; //изменяем текст кнопки 
tg.MainButton.setText("Отправить"); //изменяем текст кнопки иначе
tg.MainButton.textColor = "#FFFFFF"; //изменяем цвет текста кнопки
tg.MainButton.color = "#143F6B"; //изменяем цвет бэкграунда кнопки
tg.MainButton.setParams({"color": "#143F6B"}); 





const NewProducts = () => {


    
   

  return (
    <Grid container style={{ height: '100%', width: "100%", }} alignItems="center" justify="center" sx={{ pb:20, pt:12, pl:3 }} >
      <Box alignItems="center">
          <p>Скоро здесь появятся наши новинки. Ожидайте.</p>
      </Box>
    </Grid>
  );
};
 
export default NewProducts;